require('./productTemplateEditor.i18n.json');
require('./productTemplateEditor.tpl.html');
require('./productTemplateEditorRepository.js');
require('./ProductTemplateEditorModel.js');
require('./header/productTemplateEditorHeaderComponent.js');

/*@ngInject*/
const ProductTemplateEditorController = function ($rootScope, $scope, $state, $stateParams, $window, localization, configurationMediator,
                                                  productTypes, coreConstant, configurationConstant, productTemplateEditorModel,
                                                  dataSetUtil, currentUserModel, authorizationConstants, $uibModal, coreMediator) {

    var translations,
        backdatingRange =  _.range(-365, 1),
        futureDatingRange = _.range(0, 366),
        pendingBoundaryRange = _.range(0, 367),
        policyPeriodBoundary = _.range(0, 2001),
        quoteSectionOrderingRange = _.range(0, 301);


    $scope.viewModel = {
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES),
        quoteTemplateClickedForUpload: false,
        binderTemplateClickedForUpload: false,
        selectFileToUpload: '',
        id: '',
        productInfo: {
            productName: '',
            productNamePrompt: '',
            productShortName: '',
            productShortNamePrompt: '',
            externalProductName: '',
            externalProductNamePrompt: '',
            status: 'active',
            allowMultipleQuotesInProposal: 'yes',
            productType: 'both'
        },
        quotingDetails: {
            quotableForProducts: {
                quotableForProductList: [],
                selectedQuotableForProduct: [],
                initialSelectedQuotableForProduct: null,
                quotableForProductsPrompt: '',
                itemName: 'quotableForProduct'
            },
            enableRefreshQuote: 'yes',
            showForm: true
        },
        externalReport: {
            report: {reportList: [], selectedReport: [], itemName: 'report', prompt: ''},
            reportList: [],
            showForm: true
        },
        rating: {
            ratingAdapter: {ratingAdapterList: [],selectedRatingAdapter:'',prompt:''},
            ratingOutputForm: {rationOutputFormList: [], selectedRatingOutputForm: '', prompt: ''},
            useAgentRatingFormsForAgentQuoting: 'no',
            useRateStatusWhenRating: 'no',
            showForm: true
        },
        pricing: {
            enablePricingInput: 'no',
            showForm: true
        },
        quoting: {
            quotingAdapter: {quotingAdapterList: [],selectedQuotingAdapter:'',prompt:''},
            enableAgentQuotingOfAllQuotes: 'no',
            showForm: true,
            quoteSectionOrdering: {
                value: 0,
                optionList: quoteSectionOrderingRange
            },

            quoteTemplateFileName: '',
            quoteTemplateFile: null,
            quoteTemplateFileUrl: null,
            quoteFileTemplateId: 0
        },
        binding: {
            enableBindingInput: 'no',
            enableBinder: 'no',
            enableAgentBindingInput: 'no',
            enableAgentBindingOfAllQuotes: 'no',
            allowBindingOfMultiplePolicies: 'no',
            showForm: true,
            binderTemplateFileName: '',
            binderTemplateFile: null,
            binderTemplateFileUrl: null,
            binderFileTemplateId: 0
        },
        issuance: {
            policyAdapter: {policyAdapterList: [],selectedPolicyAdapter:'',prompt:''},
            enableIssuanceInput: 'no',
            showForm: true
        },
        cancellation: {
            enableAutoRequestCancellation: 'no',
            daysBeforeExpirationToAutoRequestCancellation: 1,
            disableCancellationRequest: true,
            autoRequestCancellationReason: {
                autoRequestCancellationReasonList: [],
                selectedAutoRequestCancellation: '',
                prompt: ''
            },
            allowCancellationOnPolicyExpirationDate: 'no',
            requiredFieldStyle:'hidden',
            showForm: true
        },
            endorsement: {
                allowEndorsementOnPolicyExpirationDate: 'no',
                showForm: true
            },
        effectiveDateRange: {
            backdatingBoundaryProducer: {
                value: 0,
                optionList: backdatingRange,
                checked: true
            },
            futuredatingBoundaryProducer: {
                value: 0,
                optionList: futureDatingRange,
                checked: true
            },
            submitPendingBoundaryProducer: {
                value: 0,
                optionList: pendingBoundaryRange,
                checked: true
            },
            backdatingBoundaryUnderwriter: {
                value: 0,
                optionList: backdatingRange,
                checked: true
            },
            futuredatingBoundaryUnderwriter: {
                value: 0,
                optionList: futureDatingRange,
                checked: true
            },
            submitPendingBoundaryUnderwriter: {
                value: 0,
                optionList: pendingBoundaryRange,
                checked: true
            },
            policyPeriodBoundary: {
                value: 0,
                optionList: policyPeriodBoundary,
                selectedDateType: 'days',
                checked: true
            },
            policyPeriodDateTypeList: [],
            showForm: true,
            showOnlyPolicyPeriodBoundary: true
        }

    };

    localization.getTranslationByKey('productTemplateForm').then(function (result) {
        translations = result;
        $scope.viewModel.productInfo.productNamePrompt = _.get(translations, 'productInformation.productNamePrompt');
        $scope.viewModel.productInfo.productShortNamePrompt = _.get(translations, 'productInformation.productShortNamePrompt');
        $scope.viewModel.productInfo.externalProductNamePrompt = _.get(translations, 'productInformation.externalProductNamePrompt');
        $scope.viewModel.quotingDetails.quotableForProducts.quotableForProductsPrompt = _.get(translations, 'quotingDetails.quotableForProductsPrompt');
        $scope.viewModel.externalReport.report.prompt = _.get(translations, 'externalReports.reportListPrompt');
        $scope.viewModel.rating.ratingOutputForm.prompt = _.get(translations, 'rating.ratingOutputForm.prompt');
        $scope.viewModel.rating.ratingAdapter.prompt = _.get(translations, 'rating.ratingAdapter.prompt');
        $scope.viewModel.quoting.quotingAdapter.prompt = _.get(translations, 'quoting.quotingAdapter.prompt');
        $scope.viewModel.issuance.policyAdapter.prompt = _.get(translations, 'issuance.policyAdapter.prompt');

        $scope.viewModel.cancellation.autoRequestCancellationReason.prompt = _.get(translations, 'cancellation.autoRequestCancellationReasonPrompt');
        $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList.push(_.get(translations, 'effectiveDateRange.dateType.days'));
        $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList.push(_.get(translations, 'effectiveDateRange.dateType.months'));
        $scope.viewModel.selectFileToUpload = _.get(translations, 'selectFileToUpload');
    }.bind(this));

    function init() {
        productTemplateEditorModel.setProductTemplate(null);
        productTemplateEditorModel.isValid = false;
        productTemplateEditorModel.hasUnsavedChanges = false;

        if (!_.isEmpty($stateParams.productTemplateName)) {
            configurationMediator.loadProductTemplateById($stateParams.productTemplateId).then(function (productTemplate) {
                populationForm(productTemplate);
                productTemplateEditorModel.setProductTemplate(productTemplate);
                loadDataSets();
                if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
                    $scope.viewModel.externalReport.showForm = false;
                    $scope.viewModel.effectiveDateRange.showForm = false;
                    $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
                    controlFormVisibility(true);
                } else {
                    $scope.viewModel.externalReport.showForm = true;
                    $scope.viewModel.effectiveDateRange.showForm = true;
                    if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
                        controlFormVisibility(false);
                    } else { //both
                        $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
                        controlFormVisibility(true);
                    }
                }
            });
        } else {
            productTemplateEditorModel.setProductTemplate(null);
            loadDataSets();
        }
    }

    function loadDataSets() {
        loadSubmittableProductsDataSet();

        dataSetUtil.getDataSet({name: 'Rating Adapters'}).then(function (dataset) {
            $scope.viewModel.rating.ratingAdapter.ratingAdapterList = dataset.items;
            _.each($scope.viewModel.rating.ratingAdapter.ratingAdapterList, function (ratingAdapterItem) {
                if (_.isNil(productTemplateEditorModel.getProductTemplate()) && ratingAdapterItem.name === 'Default Rating Adapter') {
                    $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter = ratingAdapterItem;
                } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().ratingAdapterBeanName === ratingAdapterItem.value) {
                    $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter = ratingAdapterItem;
                }
            });
        });

        dataSetUtil.getDataSet({name: 'External Reports'}).then(function (dataset) {
            var selectedReports;
            $scope.viewModel.externalReport.reportList = dataset.items;
            _.each($scope.viewModel.externalReport.reportList, function (externalReportGenerator) {
                if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && _.includes(productTemplateEditorModel.getProductTemplate().externalReportGeneratorBeanNames, externalReportGenerator.value)) {
                    if (_.isNil(selectedReports)) {
                        selectedReports = externalReportGenerator.value;
                    } else {
                        selectedReports += '::' + externalReportGenerator.value;
                    }
                }
            });
            $scope.viewModel.externalReport.report.selectedReport = selectedReports;
        });

        dataSetUtil.getDataSet({name: 'Quoting Adapters'}).then(function (dataset) {
            $scope.viewModel.quoting.quotingAdapter.quotingAdapterList = dataset.items;
            _.each($scope.viewModel.quoting.quotingAdapter.quotingAdapterList, function (quoteAdapter) {
                if (_.isNil(productTemplateEditorModel.getProductTemplate()) && quoteAdapter.name === 'Default Quote Adapter') {
                    $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter = quoteAdapter;
                } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().quoteAdapterBeanName === quoteAdapter.value) {
                    $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter = quoteAdapter;
                }
            });
        });

        dataSetUtil.getDataSet({name: 'Policy Adapters'}).then(function (dataset) {
            $scope.viewModel.issuance.policyAdapter.policyAdapterList = dataset.items;
            _.each($scope.viewModel.issuance.policyAdapter.policyAdapterList, function (policyAdapter) {
                if (_.isNil(productTemplateEditorModel.getProductTemplate()) && policyAdapter.name === 'Default Policy Adapter') {
                    $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter = policyAdapter;
                } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().policyAdapterBeanName === policyAdapter.value) {
                    $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter = policyAdapter;
                }
            });
        });

        dataSetUtil.getDataSet({name: 'Rating Forms'}).then(function (dataset) {
            $scope.viewModel.rating.ratingOutputForm.rationOutputFormList = dataset.items;
            _.each($scope.viewModel.rating.ratingOutputForm.rationOutputFormList, function (rationOutputForm) {
                if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && rationOutputForm.name === productTemplateEditorModel.getProductTemplate().ratingOutputFormName) {
                    $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm = rationOutputForm;
                }
            });
        });

        dataSetUtil.getDataSet({name: 'Cancellation Reasons'}).then(function (dataset) {
            $scope.viewModel.cancellation.autoRequestCancellationReason.autoRequestCancellationReasonList = dataset.items;
            _.each($scope.viewModel.cancellation.autoRequestCancellationReason.autoRequestCancellationReasonList, function (autoRequestCancellationReason) {
                if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && autoRequestCancellationReason.name === productTemplateEditorModel.getProductTemplate().autoRequestCancellationReason) {
                    $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation = autoRequestCancellationReason;
                }
            });
        });
    }

    function isFieldValid() {
        var result = false, // we need to always return something if the method is intended to return something
            hasProductInfo = !_.isEmpty($scope.viewModel.productInfo.productName) && !_.isEmpty($scope.viewModel.productInfo.productShortName),
            isSubmitableProduct = $scope.viewModel.productInfo.productType === productTypes.SUBMITABLE,
            hasRatingAdapter = !_.isNil($scope.viewModel.rating.ratingAdapter.selectedRatingAdapter),
            hasQuotingAdapter = !_.isNil($scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter),
            hasPolicyAdapter = !_.isNil($scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter),
            hasRatingQuotingAndPolicyAdapter = hasRatingAdapter && hasQuotingAdapter && hasPolicyAdapter,
            cancellationViewModel = $scope.viewModel.cancellation,
            shouldEnableAutoRequestCancellation = cancellationViewModel.enableAutoRequestCancellation === 'yes',
            hasAutoRequestCancelationSelection = !_.isNil(cancellationViewModel.autoRequestCancellationReason.selectedAutoRequestCancellation) && !_.isEmpty(cancellationViewModel.autoRequestCancellationReason.selectedAutoRequestCancellation);

        if (hasProductInfo) {
            if (isSubmitableProduct) {
                result = true;
            }
            else if (hasRatingQuotingAndPolicyAdapter) {

                if (shouldEnableAutoRequestCancellation) {
                    if (hasAutoRequestCancelationSelection) {
                        result = true;
                    }
                }
                else {
                    result = true;
                }
            }
        }
        return result;
    }

    function updateProductTemplateModel() {
        var productTemplate = {},
            ratingOutputFormDataItem = $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm,
            selectedRatingAdapterDataItem = $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter,
            selectedQuotingAdapterDataItem = $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter,
            selectedPolicyAdapterDataItem = $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter,
            selectedAutoRequestCancellationDataItem = $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation,
            selectedDateType = $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType;

        var unlimited = 'Unlimited';
        if (!_.isNil(productTemplateEditorModel.getProductTemplate())) {
            productTemplate.id = productTemplateEditorModel.getProductTemplate().id;
        }
        productTemplate.name = $scope.viewModel.productInfo.productName;
        productTemplate.shortName = $scope.viewModel.productInfo.productShortName;
        productTemplate.externalName = $scope.viewModel.productInfo.externalProductName;
        productTemplate.active = $scope.viewModel.productInfo.status === 'active';
        productTemplate.allowMultiQuoteProposals = $scope.viewModel.productInfo.allowMultipleQuotesInProposal === 'yes';

        if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
            productTemplate.selectableOnSubmission = true;
            productTemplate.selectableOnQuote = false;
        } else if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
            productTemplate.selectableOnQuote = true;
            productTemplate.selectableOnSubmission = false;
        } else {
            productTemplate.selectableOnSubmission = true;
            productTemplate.selectableOnQuote = true;
        }

        // Quotable for products
        // Set submissionProductTemplates
        // Convert collection value to :: separated Ids
        productTemplate.submissionProductTemplates = _.join(_.map($scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct, 'value'), '::');

        productTemplate.enableRefreshQuote = $scope.viewModel.quotingDetails.enableRefreshQuote === 'yes';
        productTemplate.quoteSectionOrdering = $scope.viewModel.quoting.quoteSectionOrdering.value;

        // Report List
        if ($scope.viewModel.externalReport.report.selectedReports && $scope.viewModel.externalReport.report.selectedReports.length > 0) {
            // Convert collection value to :: separated external report bean name
            productTemplate.externalReportGeneratorBeanNames = _.replace(_.map($scope.viewModel.externalReport.report.selectedReports, 'value').toString(), new RegExp(',', 'g'), '::');
        } else if ($scope.viewModel.externalReport.report.selectedReports && $scope.viewModel.externalReport.report.selectedReports.length === 0) {
            productTemplate.externalReportGeneratorBeanNames = null;
        }

        productTemplate.useAgentRatingFormsForAgentQuoting = $scope.viewModel.rating.useAgentRatingFormsForAgentQuoting === 'yes';
        productTemplate.ratingOutputFormName = dataSetUtil.getDataItemValue(ratingOutputFormDataItem);
        productTemplate.ratingAdapterBeanName = dataSetUtil.getDataItemValue(selectedRatingAdapterDataItem);
        productTemplate.useRateStatusWhenRating = $scope.viewModel.rating.useRateStatusWhenRating === 'yes';
        productTemplate.agentQuoteAllQuotes = $scope.viewModel.quoting.enableAgentQuotingOfAllQuotes === 'yes';
        productTemplate.pricingFormEnabled = $scope.viewModel.pricing.enablePricingInput === 'yes';
        productTemplate.quoteAdapterBeanName = dataSetUtil.getDataItemValue(selectedQuotingAdapterDataItem);
        productTemplate.bindingFormEnabled = $scope.viewModel.binding.enableBindingInput === 'yes';
        productTemplate.binderEnabled = $scope.viewModel.binding.enableBinder === 'yes';
        productTemplate.agentBindingFormEnabled = $scope.viewModel.binding.enableAgentBindingInput === 'yes';
        productTemplate.agentBindAllQuotes = $scope.viewModel.binding.enableAgentBindingOfAllQuotes === 'yes';
        productTemplate.allowBindingMultiplePolicies = $scope.viewModel.binding.allowBindingOfMultiplePolicies === 'yes';
        productTemplate.policyAdapterBeanName = dataSetUtil.getDataItemValue(selectedPolicyAdapterDataItem);
        productTemplate.issuanceFormEnabled = $scope.viewModel.issuance.enableIssuanceInput === 'yes';
        productTemplate.autoRequestCancellationFlag = $scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes';
        productTemplate.autoRequestCancellationDaysBeforeExpiration = $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation;
        productTemplate.autoRequestCancellationReason = dataSetUtil.getDataItemValue(selectedAutoRequestCancellationDataItem);
        productTemplate.allowCancellationOnPolicyExpirationDate = $scope.viewModel.cancellation.allowCancellationOnPolicyExpirationDate === 'yes';
        productTemplate.allowEndorsementOnPolicyExpirationDate = $scope.viewModel.endorsement.allowEndorsementOnPolicyExpirationDate === 'yes';

        productTemplate.producerBackdateBoundary = $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value;
        productTemplate.producerFuturedateBoundary = $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value;
        productTemplate.producerSubmitPendingBoundary = $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value;
        productTemplate.uwBackdateBoundary = $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value;
        productTemplate.uwFuturedateBoundary = $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value;
        productTemplate.uwSubmitPendingBoundary = $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value;
        productTemplate.policyDateRangeBoundary = $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked ? unlimited : $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value;
        productTemplate.policyDateRangeBoundaryUnit = (!_.isEmpty(selectedDateType) ?
                                                           selectedDateType :
                                                           $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked ? 'days' : null);

        productTemplate.quoteTemplateFileName = $scope.viewModel.quoting.quoteTemplateFileName;
        productTemplate.binderTemplateFileName = $scope.viewModel.binding.binderTemplateFileName;
        productTemplate.quoteFileTemplateId = $scope.viewModel.quoting.quoteFileTemplateId;
        productTemplate.binderFileTemplateId = $scope.viewModel.binding.binderFileTemplateId;
        productTemplateEditorModel.setProductTemplate(productTemplate);
        productTemplateEditorModel.setQuoteTemplateFile($scope.viewModel.quoting.quoteTemplateFile);
        productTemplateEditorModel.setBinderTemplateFile($scope.viewModel.binding.binderTemplateFile);

    }

    function populationForm(productTemplate) {
        $scope.viewModel.id = productTemplate.id;

        $scope.viewModel.productInfo.productName = productTemplate.name;
        $scope.viewModel.productInfo.productShortName = productTemplate.shortName;
        $scope.viewModel.productInfo.externalProductName = productTemplate.externalName;
        $scope.viewModel.productInfo.status = productTemplate.active ? 'active' : 'inactive';
        $scope.viewModel.productInfo.allowMultipleQuotesInProposal = productTemplate.allowMultiQuoteProposals ? 'yes' : 'no';

        if (productTemplate.selectableOnSubmission && productTemplate.selectableOnQuote) {
            $scope.viewModel.productInfo.productType = 'both';
        } else {
            if (productTemplate.selectableOnSubmission) {
                $scope.viewModel.productInfo.productType = productTypes.SUBMITABLE;
            } else {
                $scope.viewModel.productInfo.productType = productTypes.QUOTEABLE;
            }
        }
        $scope.viewModel.quotingDetails.enableRefreshQuote = productTemplate.enableRefreshQuote ? 'yes' : 'no';
        $scope.viewModel.quoting.quoteSectionOrdering.value = productTemplate.quoteSectionOrdering;
        $scope.viewModel.rating.useAgentRatingFormsForAgentQuoting = productTemplate.useAgentRatingFormsForAgentQuoting ? 'yes' : 'no';
        $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm = productTemplate.ratingOutputFormName;
        $scope.viewModel.rating.useRateStatusWhenRating = productTemplate.useRateStatusWhenRating ? 'yes' : 'no';
        $scope.viewModel.pricing.enablePricingInput = productTemplate.pricingFormEnabled ? 'yes' : 'no';
        $scope.viewModel.quoting.enableAgentQuotingOfAllQuotes = productTemplate.agentQuoteAllQuotes ? 'yes' : 'no';
        $scope.viewModel.binding.enableBindingInput = productTemplate.bindingFormEnabled ? 'yes' : 'no';
        $scope.viewModel.binding.enableBinder = productTemplate.binderEnabled ? 'yes' : 'no';
        $scope.viewModel.binding.enableAgentBindingInput = productTemplate.agentBindingFormEnabled ? 'yes' : 'no';
        $scope.viewModel.binding.enableAgentBindingOfAllQuotes = productTemplate.agentBindAllQuotes ? 'yes' : 'no';
        $scope.viewModel.binding.allowBindingOfMultiplePolicies = productTemplate.allowBindingMultiplePolicies ? 'yes' : 'no';
        $scope.viewModel.issuance.enableIssuanceInput = productTemplate.issuanceFormEnabled ? 'yes' : 'no';
        $scope.viewModel.cancellation.enableAutoRequestCancellation = productTemplate.autoRequestCancellationFlag ? 'yes' : 'no';

        if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
            $scope.viewModel.cancellation.disableCancellationRequest = false;
            $scope.viewModel.cancellation.requiredFieldStyle = '';
        } else {
            $scope.viewModel.cancellation.disableCancellationRequest = true;
            $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
        }

        $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = productTemplate.autoRequestCancellationDaysBeforeExpiration;
        $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation = productTemplate.autoRequestCancellationReason;
        $scope.viewModel.cancellation.allowCancellationOnPolicyExpirationDate = productTemplate.allowCancellationOnPolicyExpirationDate ? 'yes' : 'no';
        $scope.viewModel.endorsement.allowEndorsementOnPolicyExpirationDate = productTemplate.allowEndorsementOnPolicyExpirationDate ? 'yes' : 'no';

        if (productTemplate.producerBackdateBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked = true;
            $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked = false;
            $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value = productTemplate.producerBackdateBoundary;
        }

        if (productTemplate.producerFuturedateBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked = true;
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked = false;
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value = productTemplate.producerFuturedateBoundary;
        }

        if (productTemplate.producerSubmitPendingBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked = true;
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked = false;
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value = productTemplate.producerSubmitPendingBoundary;
        }

        if (productTemplate.uwBackdateBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked = true;
            $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked = false;
            $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value = productTemplate.uwBackdateBoundary;
        }


        if (productTemplate.uwFuturedateBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked = true;
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked = false;
            $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value = productTemplate.uwFuturedateBoundary;
        }

        if (productTemplate.uwSubmitPendingBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked = true;
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value = '';
        } else {
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked = false;
            $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value = productTemplate.uwSubmitPendingBoundary;
        }

        if (productTemplate.policyDateRangeBoundary === 'Unlimited') {
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked = true;
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value = '';
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = '';
        } else {
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked = false;
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value = productTemplate.policyDateRangeBoundary;
            $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = !_.isEmpty(productTemplate.policyDateRangeBoundaryUnit)? productTemplate.policyDateRangeBoundaryUnit:'days';
        }

        $scope.viewModel.quoting.quoteTemplateFileName = productTemplate.quoteTemplateFileName;
        $scope.viewModel.quoting.quoteFileTemplateId = productTemplate.quoteFileTemplateId;
        $scope.viewModel.binding.binderTemplateFileName = productTemplate.binderTemplateFileName;
        $scope.viewModel.binding.binderFileTemplateId = productTemplate.binderFileTemplateId;
    }

    function getDownloadUrl(templateType) {
        let templateFileName,
            templateFileId,
            templateFileNamePath,
            templateFileNameParameter;

        if (templateType === 'quote') {
            templateFileName = $scope.viewModel.quoting.quoteTemplateFileName;
            templateFileId = $scope.viewModel.quoting.quoteFileTemplateId;
        } else  if (templateType === 'binder') {
            templateFileName = $scope.viewModel.binding.binderTemplateFileName;
            templateFileId = $scope.viewModel.binding.binderFileTemplateId;
        }

        return coreMediator.getSingleUseToken().then((token) => {
            templateFileNamePath = templateFileName ? '/' + encodeURIComponent(templateFileName) : '';
            templateFileNameParameter = templateFileName ? ' filename="' + encodeURIComponent(templateFileName) + '"' : '';
            return `/productTemplateFileDownload${templateFileNamePath}?id=${templateFileId}&t=${encodeURIComponent(token)}&contentDisposition=inline;${templateFileNameParameter}`;
        });
    }

    function loadSubmittableProductsDataSet() {
        return dataSetUtil.getDataSet({
            name: 'Product Templates By Type',
            search: productTypes.SUBMITABLE
        }).then(function (dataset) {
            var selectedProducts = [],
                currentProductTemplate = productTemplateEditorModel.getProductTemplate();

            // Filter out the current product template.
            $scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList = _.filter(dataset.items, function (productTemplate) {
                if (currentProductTemplate) {
                    return currentProductTemplate.id !== parseInt(productTemplate.value);
                }
                return true;
            });

            _.each($scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList, function (quoteableForProduct) {
                if (!_.isNil(currentProductTemplate) && _.includes(currentProductTemplate.submissionProductTemplateIds, parseInt(quoteableForProduct.value))) {
                    $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct.push(quoteableForProduct);
                    selectedProducts.push(quoteableForProduct.value);
                }
            });
            $scope.viewModel.quotingDetails.quotableForProducts.initialSelectedQuotableForProduct = _.join(selectedProducts, '::');
        });
    }

    function controlFormVisibility(show) {
        $scope.viewModel.quotingDetails.showForm = show;
        $scope.viewModel.rating.showForm = show;
        $scope.viewModel.pricing.showForm = show;
        $scope.viewModel.quoting.showForm = show;
        $scope.viewModel.binding.showForm = show;
        $scope.viewModel.issuance.showForm = show;
        $scope.viewModel.cancellation.showForm = show;
        $scope.viewModel.endorsement.showForm = show;
    }

    $scope.onEnableAutoRequestCancellationChange = function () {
        $scope.handleChange();
        if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
            $scope.viewModel.cancellation.disableCancellationRequest = false;
            $scope.viewModel.cancellation.requiredFieldStyle = '';
        } else {
            $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
            $scope.viewModel.cancellation.disableCancellationRequest = true;
        }
    };

    $scope.onEnableAutoRequestCancellationChange = function () {
        $scope.handleChange();
        if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
            $scope.viewModel.cancellation.disableCancellationRequest = false;
            $scope.viewModel.cancellation.requiredFieldStyle = '';
        } else {
            $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
            $scope.viewModel.cancellation.disableCancellationRequest = true;
        }
    };

    $scope.onToggleUnlimitedEffectiveDateCheckbox = function (effectiveDateContext) {
        var isPolicyPeriodBoundary = _.has(effectiveDateContext, 'selectedDateType');

        if(effectiveDateContext['checked']) {
            effectiveDateContext['value'] = '';

            if(isPolicyPeriodBoundary) {
                effectiveDateContext['selectedDateType'] = '';
            }
        }
        else {
            effectiveDateContext['value'] = 0;

            if(isPolicyPeriodBoundary) {
                effectiveDateContext['selectedDateType'] = $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList[0];
            }
        }

        $scope.handleChange();
    };

    $scope.handleChange = function () {
        productTemplateEditorModel.hasUnsavedChanges = true;
        productTemplateEditorModel.isValid = isFieldValid();
        updateProductTemplateModel();
        $rootScope.$broadcast(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED);
    };

    $scope.onProductTypeChange = function () {
        if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
            $scope.viewModel.externalReport.showForm = false;
            $scope.viewModel.effectiveDateRange.showForm = false;
            $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
            controlFormVisibility(true);
        } else {
            $scope.viewModel.externalReport.showForm = true;
            $scope.viewModel.effectiveDateRange.showForm = true;
            if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
                controlFormVisibility(false);
            } else {
                $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
                controlFormVisibility(true);
            }
        }

        loadSubmittableProductsDataSet().then(function () {
            $scope.handleChange();
        });
    };

    $scope.onEnableAutoRequestCancellationChange = function () {
        $scope.handleChange();
        if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
            $scope.viewModel.cancellation.disableCancellationRequest = false;
            $scope.viewModel.cancellation.requiredFieldStyle = '';
        } else {
            $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
            $scope.viewModel.cancellation.disableCancellationRequest = true;
        }
    };

    $scope.handleDaysBeforeExpirationToAutoRequestCancellation = function () {
        $scope.handleChange();
        if (_.isNaN(parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation))) {
            $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 0;
        } else {
            if (parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation) < 0) {
                $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 0;
            } else if (parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation) > 300) {
                $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 300;
            }
        }
        $scope.handleChange();

    };

    $scope.onPolicyPeriodBoundarySelectItem = function(item) {
        $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = item;
        $scope.handleChange();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
        if (itemName === $scope.viewModel.quotingDetails.quotableForProducts.itemName) {
            $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct = [];
            _.each($scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList, function (quotableForProducts) {
                if (quotableForProducts.selected) {
                    $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct.push(quotableForProducts);
                }
            });
        } else if (itemName === $scope.viewModel.externalReport.report.itemName) {
            $scope.viewModel.externalReport.report.selectedReports = [];
            _.each($scope.viewModel.externalReport.reportList, function (report) {
                if (report.selected) {
                    $scope.viewModel.externalReport.report.selectedReports.push(report);
                }
            });
        }
        $scope.handleChange();
    });

    $scope.$on(coreConstant.event.FILE_UPLOADED, function (event, file) {
        if ($scope.viewModel.quoteTemplateClickedForUpload) {
            $scope.viewModel.quoting.quoteTemplateFileName = file.name;
            $scope.viewModel.quoting.quoteTemplateFile = file.uploadedFile;
            // Just a placeholder to make sure quoteFileTemplate needs to saved
            $scope.viewModel.quoting.quoteFileTemplateId = -1;
        } else if ($scope.viewModel.binderTemplateClickedForUpload) {
            $scope.viewModel.binding.binderTemplateFileName = file.name;
            $scope.viewModel.binding.binderTemplateFile = file.uploadedFile;
            // Just a placeholder to make sure binderFileTemplate needs to saved
            $scope.viewModel.binding.binderFileTemplateId = -1;
        }
        $scope.handleChange();
        $scope.viewModel.quoteTemplateClickedForUpload = false;
        $scope.viewModel.binderTemplateClickedForUpload = false;
    });

    $scope.openFileDialogBox = function(templateName) {
        if (templateName === 'quote') {
            $scope.viewModel.quoteTemplateClickedForUpload = true;
        } else  if (templateName === 'binder') {
            $scope.viewModel.binderTemplateClickedForUpload = true;
        }

        $uibModal.open({
            templateUrl: '/configuration/uploadDocument/uploadDocumentModal.tpl.html',
            controller: 'uploadDocumentModalController',
            windowClass: 'uploadDocumentModal',
            resolve: {

            },
            keyboard: false,
            backdrop: 'static'
        });
    };

    $scope.onCloseButtonClicked = function(closeTemplate) {
        if (closeTemplate === 'quote') {
            $scope.viewModel.quoting.quoteTemplateFile = null;
            $scope.viewModel.quoting.quoteTemplateFileName = null;
            $scope.viewModel.quoting.quoteFileTemplateId = null;
        } else if (closeTemplate === 'binder') {
            $scope.viewModel.binding.binderTemplateFile = null;
            $scope.viewModel.binding.binderTemplateFileName = null;
            $scope.viewModel.binding.binderFileTemplateId = null;
        }
        $scope.handleChange();
    };

    $scope.onTemplateFileDownloadClick = function(templateType) {
        if (templateType === 'quote') {
            getDownloadUrl('quote').then((url) => {
                $window.open(url, '_blank');
            });
        } else if (templateType === 'binder') {
            getDownloadUrl('binder').then((url) => {
                $window.open(url, '_blank');
            });
        }
    };

    $scope.displayQuoteDocTemplateButton = function() {
        return $scope.viewModel.quoting.quoteTemplateFileName === '' || $scope.viewModel.quoting.quoteTemplateFileName === null;
    };

    $scope.displayQuoteDocTemplateLink = function() {
        return $scope.viewModel.quoting.quoteTemplateFileName !== '' && $scope.viewModel.quoting.quoteTemplateFileName !== null && $scope.viewModel.quoting.quoteFileTemplateId !== -1;
    };

    $scope.displayQuoteDocTemplateFileName = function() {
        return $scope.viewModel.quoting.quoteTemplateFileName !== '' && $scope.viewModel.quoting.quoteTemplateFileName !== null && $scope.viewModel.quoting.quoteFileTemplateId == -1;
    };

    $scope.displayBinderDocTemplateButton = function() {
        return $scope.viewModel.binding.binderTemplateFileName === '' || $scope.viewModel.binding.binderTemplateFileName === null;
    };

    $scope.displayBinderDocTemplateLink = function() {
        return $scope.viewModel.binding.binderTemplateFileName !== '' && $scope.viewModel.binding.binderTemplateFileName !== null && $scope.viewModel.binding.binderFileTemplateId !== -1;
    };

    $scope.displayBinderDocTemplateFileName = function() {
        return $scope.viewModel.binding.binderTemplateFileName !== '' && $scope.viewModel.binding.binderTemplateFileName !== null && $scope.viewModel.binding.binderFileTemplateId == -1;
    };
    init();
};

angular.module('ums.configuration')
    .controller('productTemplateEditorController', ProductTemplateEditorController);
